<template>
	<div class="center">
		<button class="center call" @click="start">
			Start now
			<v-icon name="chevron-right" style="margin-left: 8px" />
		</button>
	</div>
</template>

<script>
export default {
	methods: {
		start() {
			alert("Wait for it! It's coming.");
			//window.open("", "_blank");
			var userAgent = window.navigator.userAgent,
				platform = window.navigator.platform,
				macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
				windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
				iosPlatforms = ["iPhone", "iPad", "iPod"],
				os = null;

			if (macosPlatforms.indexOf(platform) !== -1) {
				os = "Mac OS";
			} else if (iosPlatforms.indexOf(platform) !== -1) {
				os = "iOS";
			} else if (windowsPlatforms.indexOf(platform) !== -1) {
				os = "Windows";
			} else if (/Android/.test(userAgent)) {
				os = "Android";
			} else if (!os && /Linux/.test(platform)) {
				os = "Linux";
			}
			if (os === "iOS") {
				return;
			} else if (os === "Android") {
				return;
			} else {
				return;
			}
		},
	},
};
</script>

<style scoped>
.call {
	background: linear-gradient(#3385ff, #5b9dff);
	color: white;
	border: 0;
	border-radius: 50px;
	font-size: 18px;
	font-weight: bold;
	padding: 10px 16px;
}
</style>
